<form [formGroup]="form" (ngSubmit)="saveExpenseType()">
    <div class="grid">
        <div class="col-12 md:col-6">
            <div class="form-group mb-3">
                <label class="form-label">Expense Category Name*</label>
                <input type="text" pInputText [formControlName]="'name'" name="name" autocomplete="off"
                    class="form-control" />
                <div *ngIf="form.get('name').invalid && form.get('name').touched" class="text-danger">
                    Name is required.
                </div>
            </div>
            <div class="form-group">
                <label class="form-label">Type</label>
                <div class="flex justify-content-center">
                    <p-dropdown [formControlName]="'type'" [style]="{ width: '100%'}"
                        [options]="mainExpenseTypeDropdown" optionLabel="name" optionValue="id"
                        placeholder="Select a Type" name="type"></p-dropdown>
                </div>
            </div>
            <div class="form-group mt-3">
                <textarea [rows]="5" [style]="{ width: '100%' }" pInputTextarea [formControlName]="'description'"
                    name="description" placeholder="Description"></textarea>
                <div *ngIf="
                    form.get('description').invalid && form.get('description').touched
                    " class="text-danger">
                            Description is required.
                        </div>
            </div>
        </div>
        <div class="col-12 md:col-6">
            <div class="form-group">
                <label class="form-label">Icon</label><br />
                <div class="p-4">
                    <p-selectButton [options]="iconOptions" [formControlName]="'icon'" optionLabel="name" name="icon"
                        optionValue="value">
                        <ng-template let-item pTemplate>
                            <i [class]="item.name"></i>
                        </ng-template>
                    </p-selectButton>
                    <div *ngIf="
                form.get('icon').invalid && form.get('icon').touched
                " class="text-danger">
                        Icon is required.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- <ng-template pTemplate="footer"> -->
    <div class="flex justify-content-center align-items-center gap-2 mt-2 mb-2">
        <p-button label="Cancel" styleClass="p-button-outlined px-4" pAutoFocus [autofocus]="true" (click)="exitForm()"></p-button>
        <p-button type="submit" label="Save" styleClass="px-4" [disabled]="disableSave"></p-button>
    </div>

    <!-- </ng-template> -->
</form>